import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-down-small",
  "use": "icon-caret-down-small-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caret-down-small\">\r\n<g id=\"icon-caret-down-small_caret-down-small\">\r\n<rect width=\"14\" height=\"14\" rx=\"3\" fill=\"white\" />\r\n<path id=\"icon-caret-down-small_Union\" d=\"M6.99989 9.62496L11.0832 5.54163H2.9165L6.99989 9.62496Z\" fill=\"#69718C\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol